export default __webpack_public_path__ + "static/media/First.b51ee025.mp4";